<div class="screen-container d-flex fd-col ai-stretch">

  <div class="top-margin d-flex fd-row flex-wrap ai-stretch">
    <h4 class="margin">Saved Filters</h4>
  </div>
  <div class="d-flex fd-row flex-wrap ai-stretch">
    <div class="margin card flex-1 d-flex fd-col ai-stretch">
      <div class="padding">
        <p>Manage your saved filters here.</p>
      </div>
    </div>
  </div>

  <div class="d-flex fd-row flex-wrap ai-stretch">
    <h4 class="margin">Email Preferences</h4>
  </div>
  <div class="d-flex fd-row flex-wrap ai-stretch">
    <div class="margin card flex-1 d-flex fd-col ai-stretch">
      <div class="padding">
        <p>Manage your email notification preferences here.</p>
      </div>
    </div>
  </div>

  <div class="d-flex fd-row flex-wrap ai-stretch">
    <h4 class="margin">Favorite Data</h4>
  </div>
  <div class="d-flex fd-row flex-wrap ai-stretch">
    <div class="margin card flex-1 d-flex fd-col ai-stretch">
      <div class="padding">
        <p>Manage your starred data here.</p>
      </div>
    </div>
  </div>
</div>